// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"cc9587bb10d639545050","151":"43dcbe39fd532354f2fa","235":"63ae07e3202094ca90b0"}[chunkId] + ".js";
};